/**
 * Email service utility for sending form data
 */
import { fetchAuthSession } from 'aws-amplify/auth';
import AWS from 'aws-sdk';

/**
 * Sends consultation form data via AWS SES
 * 
 * @param {Object} formData - The form data to send
 * @returns {Promise} - A promise that resolves when the email is sent
 */
export const sendConsultationEmail = async (formData) => {
  try {
    const session = await fetchAuthSession();
    const credentials = session.credentials;
    
    AWS.config.update({
      region: 'us-east-1',
      credentials: {
        accessKeyId: credentials.accessKeyId,
        secretAccessKey: credentials.secretAccessKey,
        sessionToken: credentials.sessionToken
      }
    });
    
    const emailBody = `
CONTACT INFORMATION:
Name: ${formData.name}
Email: ${formData.email}
Company: ${formData.company || 'Not provided'}
Phone: ${formData.phone || 'Not provided'}

PROJECT TYPE: ${formData.projectType || 'Custom AI Solution'}

PROJECT DETAILS:
${formData.projectDetails || 'Not provided'}

PREFERRED CONTACT TIME:
Date: ${formData.preferredDate || 'Not specified'}
Time: ${formData.preferredTime || 'Not specified'}

Timestamp: ${new Date().toISOString()}
`;
    
    const ses = new AWS.SES();
    const emailParams = {
      Source: 'info@relufox.ai',
      Destination: {
        ToAddresses: ['info@relufox.ai']
      },
      Message: {
        Subject: {
          Data: `Consultation Request: ${formData.projectType || 'Custom AI Solution'}`
        },
        Body: {
          Text: {
            Data: emailBody
          }
        }
      }
    };
    
    const result = await ses.sendEmail(emailParams).promise();
    return { success: true, messageId: result.MessageId };
    
  } catch (error) {
    console.error('Error sending consultation email:', error);
    throw error;
  }
};



/**
 * Sends data upload notification via AWS SES
 * 
 * @param {Object} uploadDetails - The upload details to send
 * @returns {Promise} - A promise that resolves when the email is sent
 */
export const sendDataUploadNotification = async (uploadDetails) => {
  try {
    const session = await fetchAuthSession();
    const credentials = session.credentials;
    
    AWS.config.update({
      region: 'us-east-1',
      credentials: {
        accessKeyId: credentials.accessKeyId,
        secretAccessKey: credentials.secretAccessKey,
        sessionToken: credentials.sessionToken
      }
    });
    
    const emailBody = `A new file has been uploaded for data preparation analysis:

CONTACT INFORMATION:
Name: ${uploadDetails.userInfo.name}
Email: ${uploadDetails.userInfo.email}
Company: ${uploadDetails.userInfo.company || 'Not provided'}
Phone: ${uploadDetails.userInfo.phone || 'Not provided'}

FILE DETAILS:
File: ${uploadDetails.fileName}
Size: ${uploadDetails.size}
Type: ${uploadDetails.type}
Upload Key: ${uploadDetails.uploadKey}

Timestamp: ${new Date().toISOString()}

Please review and process the file.`;
    
    const ses = new AWS.SES();
    const emailParams = {
      Source: 'info@relufox.ai',
      Destination: {
        ToAddresses: ['info@relufox.ai']
      },
      Message: {
        Subject: {
          Data: 'New Data Upload - Fox River AI'
        },
        Body: {
          Text: {
            Data: emailBody
          }
        }
      }
    };
    
    const result = await ses.sendEmail(emailParams).promise();
    return { success: true, messageId: result.MessageId };
    
  } catch (error) {
    console.error('Error sending data upload notification:', error);
    throw error;
  }
};